import React, { useState } from 'react'
import { navigate, Link } from '@reach/router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSpinner,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons'
import queryString from 'query-string'

import Messages from '../components/messages/Messages'
import PublicContainer from '../components/containers/PublicContainer'
import CenterLayout from '../components/ui/layouts/CenterLayout'
import SignupForm from '../components/signup/SignupForm'
import LogoUFFS from '../components/ui/LogoUFFS'

export default ({ location }) => {
  const values = queryString.parse(location.search)

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isCompleted, setIsCompleted] = useState(false)
  const [hasErrors, setHasErrors] = useState(false)
  const [backToCaptive] = useState(values.backToCaptive ? true : false)

  return (
    <PublicContainer>
      <div className="signup-page">
        <CenterLayout>
          <div className="login-button">
            <Link
              className="button is-primary is-inverted is-small"
              to="/login"
            >
              Entrar
            </Link>
          </div>

          <LogoUFFS />

          <div className="box">
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <h1 className="title is-3">Bem-vindo à UFFS</h1>
              <p className="subtitle is-5">
                Efetue seu cadastro para acessar a rede da UFFS e navegar na
                internet
              </p>
            </div>

            <Messages />

            <div className="notification is-warning">
              <strong>Atenção!</strong> O acesso à rede da UFFS para visitantes
              é destinado apenas a pessoas que irão participar de eventos
              institucionais e para trabalhadores terceirizados que estejam
              prestando serviço para a instituição e necessitam de acesso a
              internet para suas atividades. Qualquer outro tipo de solicitação
              de acesso a esta rede não será atendida.
            </div>

            {isSubmitting && !isCompleted && (
              <div className="notification">
                <FontAwesomeIcon icon={faSpinner} size="lg" spin />
                &nbsp;&nbsp;Enviando dados...
              </div>
            )}

            {hasErrors && (
              <div className="notification is-danger">
                <FontAwesomeIcon icon={faExclamationTriangle} size="lg" />
                &nbsp;&nbsp;
                {hasErrors.message.replace('GraphQL error:', '').trim()}
              </div>
            )}

            <SignupForm
              onSubmit={() => {
                setIsSubmitting(true)
                setIsCompleted(false)
                setHasErrors(false)
              }}
              onCompleted={() => {
                setIsSubmitting(false)
                setIsCompleted(true)
                setHasErrors(false)
                navigate(
                  `/signup-success${backToCaptive ? '?backToCaptive=true' : ''}`
                )
              }}
              onError={(error) => {
                setIsSubmitting(false)
                setIsCompleted(false)
                setHasErrors(error)
              }}
            />
          </div>

          <div className="box-footer">
            <p>
              Ao entrar você estará reconhecendo e aceitando os termos da{' '}
              <a
                href="https://www.uffs.edu.br/atos-normativos/portaria/gr/2018-0216"
                target="_blank"
                style={{ color: '#fff', textDecoration: 'underline' }}
                rel="noopener noreferrer"
              >
                Política de Segurança da Informação e Comunicações da UFFS
              </a>
              .
            </p>
            <br />

            <p>
              Diretoria de Infraestrutura de Informações - DITI
              <br /> Secretaria Especial de Tecnologia e Informação - SETI
            </p>
          </div>
        </CenterLayout>
      </div>
    </PublicContainer>
  )
}
